import { addDays, startOfDay } from 'date-fns'
import { fromZonedTime } from 'date-fns-tz'
import type { ListEventLogsParams } from 'api/admin/eventLogs/listEventLogs'
import { getLocalTimezone } from 'lib/time'
import { filtersFormSchema, type FiltersFormValues } from './filtersSchema'

export type BuildListEventLogsParamsResult =
  | { ok: true; params: Omit<ListEventLogsParams, 'cursor'> }
  | { ok: false; message: string }

const hasValue = <T>(value: T): value is NonNullable<T> =>
  value !== null && value !== undefined

export function buildListEventLogsParams(
  values: FiltersFormValues
): BuildListEventLogsParamsResult {
  const parsed = filtersFormSchema.safeParse(values)
  if (!parsed.success) {
    return {
      ok: false,
      message: parsed.error.issues[0]?.message ?? 'Invalid filters.',
    }
  }

  const { dateRange, companyId, userId, subjectUserId, shiftId, limit } =
    parsed.data
  const tz = getLocalTimezone()
  const startsAt = fromZonedTime(startOfDay(dateRange.from), tz).toISOString()
  const endsAt = fromZonedTime(
    addDays(startOfDay(dateRange.to), 1),
    tz
  ).toISOString()

  const eventType = parsed.data.eventType
    .split(',')
    .map((s) => s.trim())
    .filter((s) => s.length > 0)
  const message = parsed.data.messageContains.trim()

  return {
    ok: true,
    params: {
      startsAt,
      endsAt,
      ...(hasValue(companyId) && { companyId }),
      ...(hasValue(userId) && { userId }),
      ...(hasValue(subjectUserId) && { subjectUserId }),
      ...(hasValue(shiftId) && { shiftId }),
      ...(eventType.length > 0 && { eventType }),
      ...(message.length > 0 && { messageContains: message }),
      limit,
    },
  }
}
